_ = require('lodash')

angular.module('workflow.app')

.factory( 'Collection', ( Model, $filter, $timeout ) ->

  typeIsArray = ( value ) ->
    value and
      typeof value is 'object' and
      value instanceof Array and
      typeof value.length is 'number' and
      typeof value.splice is 'function' and
      not ( value.propertyIsEnumerable 'length' )

  class Collection

    @decorate = ( collection ) ->
      Model.extend( collection, @::)

      recordClass = @::getRecordClass()
      for record in collection
        recordClass.decorate( record )

      collection.init()
      collection

    @query = ( options, allowErrors = false ) ->
      api = @::getApiClass()
      queryFunction = if allowErrors then api.queryAllowingErrors else api.query

      value = @decorate( [] )
      value.$resolved = false
      value.$promise = queryFunction( options ).$promise.then ( collection ) =>
        value.$failed = not collection?
        if typeIsArray( collection )
          recordClass = @::getRecordClass()
          for item in collection
            decoratedItem = recordClass.decorate( item )
            value.push( decoratedItem )
          value.onItemsChanged()
        value.$resolved = true
        value
      value

    init: ->
      @idMap = {}
      @onItemsChanged()

    onItemsChanged: ->
      @cacheIdMap()

    cacheIdMap: ->
      @idMap = {}
      for record in @
        if record.id?
          @idMap[ record.id ] = record

    getById: ( id ) ->
      # The plus so we convert strings
      @idMap[ +id ]

    empty: ->
      @splice( 0, @length )

    set: ( itemsArray, notify = true ) ->
      @empty()
      for item in itemsArray
        @push( item )
      if notify
        @onItemsChanged()
      @

    merge: (newCollectionItems, mergeKey) ->
      existingMergeKeys = @.map(mergeKey)
      existingByMergeKey = _.zipObject(existingMergeKeys, @.slice())

      newMergeKeys = newCollectionItems.map(mergeKey)
      newByMergeKey = _.zipObject(newMergeKeys, newCollectionItems)

      merged = _.map newByMergeKey, (newRecord, key) ->
        toReturn = if key of existingByMergeKey then existingByMergeKey[key] else newRecord
        if key of existingByMergeKey
          existingByMergeKey[key].$mergeIn(newRecord)
        else
          newRecord

      @empty()
      for item in merged
        @push( item )

      @onItemsChanged()
      @

    sort: ( predicate ) ->
      sortedItems = $filter( 'orderBy' )( @, predicate )
      @set( sortedItems, false )

    isEmpty: ->
      @getCount() == 0

    getCount: ->
      @length

    _startPolling: ( options, interval, mergeKey, callback ) ->
      @stopPolling()
      @poll(options, interval, mergeKey, callback)

    poll: (options, interval, mergeKey, callback) ->
      query = () =>
        @constructor.query( options, true ).$promise.then ( newCollectionItems ) =>
          if not newCollectionItems.$failed
            @merge( newCollectionItems, mergeKey )
          callback( @ )

      @poller = $timeout(query, interval)

      currentPoller = @poller

      @poller.finally () =>
        # Make sure we don't get multiple polling chains
        if @poller == currentPoller
          @poll(options, interval, mergeKey, callback)

    stopPolling: ->
      poller = @poller
      delete @poller
      $timeout.cancel( poller ) if poller?

    isPolling: ->
      @getPoller()?

    getPoller: ->
      @poller

    newRecord: (data) ->
      apiInstance = new (@getApiClass())(data)
      record = @getRecordClass().decorate(apiInstance)
      @push(record)
      return record

    removeRecord: (record) ->
      existingRecords = @.splice()
      @empty()
      recordsToKeep = _.reject existingRecords, (existingRecord) -> existingRecord == record
      for existingRecord in recordsToKeep
        @push( existingRecord )
)
